import { render, staticRenderFns } from "./RoleDrawerFeedbacksTab.vue?vue&type=template&id=570c3f64&scoped=true&"
import script from "./RoleDrawerFeedbacksTab.vue?vue&type=script&lang=js&"
export * from "./RoleDrawerFeedbacksTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570c3f64",
  null
  
)

export default component.exports